import { Component, OnInit, OnDestroy, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, combineLatest, of, BehaviorSubject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
import { IDropdown, IDropDownService } from '../../models/search-model';
import { DropDownService } from "../../services/drop-down-service";

@Component({
  selector: 'app-branch-dropdown-simple',
  templateUrl: './branch-dropdown-simple.component.html',
  styleUrls: ['./branch-dropdown-simple.component.css']
})
export class BranchDropdownSimpleComponent implements OnInit, OnDestroy, OnChanges {
  @Input() control!: FormControl;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() fieldLabel = 'Branch';
  /** configurable: company, branch, location */
  @Input() resource: string;
  @Output() selectionChange = new EventEmitter();
  @Input() company?: any;

  private subs = new SubSink();
  filterControl = new FormControl();
  formValue$: Observable<string>;
  finalDropdown$: Observable<IDropdown[]>;
  initialDropdown$ = new BehaviorSubject<IDropdown[]>([]); // Changed to BehaviorSubject
  constructor(private ddService: DropDownService) { }

  ngOnInit() {
    this.loadBranchDropdown();
    this.formValue$ = this.filterControl.valueChanges.pipe(
      startWith(<string>null), // this string cast is just to avoid the linter from complaining
      debounceTime(300),
      distinctUntilChanged(),
    );
    this.finalDropdown$ = combineLatest([this.initialDropdown$, this.formValue$]).pipe(
      map(([branchList, search]) => {
        console.log('Branch List:', branchList, 'Search Term:', search);
        if (!search) return branchList;
        return branchList.filter(c => c.viewValue.toLocaleLowerCase().includes(search.toLocaleLowerCase()));
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes['company']);
    if (changes['company'] && !changes['company'].isFirstChange()) {
      this.loadBranchDropdown();
    }
  }

  mapContainerToDropDown = (container: IDropDownService) => (
    {
      viewValue: `${container.code?.toString()} | ${container.name?.toString()}`,
      value: container.guid?.toString()
    } as IDropdown
  );

  loadBranchDropdown(){
    const payload = { limit: 1000, orderBy: "code", order: "ASC" };
    if (this.company) {
      Object.assign(payload,
        {
          "filterConditions": [
          {
            "filterColumn": "comp_guid",
            "filterValues": [this.company],
            "filterOperator": "IN"
          }]
        }
      )
    }
    console.log("payload", payload);
    this.subs.sink = this.ddService.get(this.resource, payload, AppConfig.apiVisa).pipe(
      map(resp => resp?.data?.map(this.mapContainerToDropDown)),
      catchError(err => {
        return of([] as IDropdown[]);
      })
    ).subscribe(data => {
      this.initialDropdown$.next(data); 
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}